import type {ComponentProps} from 'react';
import {useTranslation} from 'react-i18next';
import {getFields} from 'utils/reservationSettings';
import {FORM_NAMES} from '../constants';
import {WelcomeGuestCountNote, WelcomeSteps} from '../WelcomeSteps';
import {NumberOfGuestsForm} from './NumberOfGuestsForm';

type Props = Omit<
  ComponentProps<typeof NumberOfGuestsForm>,
  | 'submitLabel'
  | 'renderHeader'
  | 'renderBeforeSubmit'
  | 'petsSubtitle'
  | 'grouped'
  | 'loadingLabel'
> & {
  isSubmitting?: boolean;
};

function WhosComingForm({isSubmitting, ...props}: Props) {
  const {t} = useTranslation();
  const visibleFields = getFields(props.seasonEntity);

  return (
    <NumberOfGuestsForm
      {...props}
      petsSubtitle={t('auth.pets_fee_hint')}
      submitLabel={totalGuests => t('confirm_n_guests', {count: totalGuests})}
      grouped
      loadingLabel={isSubmitting ? t('confirming_progress') : undefined}
      renderBeforeSubmit={totalGuests => (
        <>
          <WelcomeGuestCountNote
            bookedGuests={props.guestGroup?.known_number_of_guests}
            totalGuests={totalGuests}
            isAskingAges={!visibleFields[FORM_NAMES.numberOfGuests]}
          />
          <WelcomeSteps totalGuests={totalGuests} />
        </>
      )}
    />
  );
}

export {WhosComingForm};
